export function Accessibility({
  color = 'currentColor',
  size = 24,
  ...otherProps
}: {
  size?: number | string
} & React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden={otherProps['aria-label'] ? undefined : 'true'}
      {...otherProps}
    >
      <path d="M2 12a10 10 0 1 0 20 0a10 10 0 1 0 -20 0" />
      <path d="M9.78 17l2.22 -3.33l2.22 3.33m-2.22 -3.33v-2.22l3.33 -1.11m-6.67 0l3.33 1.11" />
      <path
        d="M11.44 7a.56 .56 0 1 0 1.11 0a.56 .56 0 1 0 -1.11 0"
        fill={color}
      />
    </svg>
  )
}
